// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Rsw5X","col":"styles_col__1B4j_"};